import React, { useEffect, useMemo } from "react";
import { MapContainer, TileLayer, Marker, useMap, Circle } from "react-leaflet";
import L from "leaflet";

const UK_CENTER = [54.2, -2.6];
const UK_ZOOM = 6;

const pinSvg = (color) => `
<svg width="34" height="46" viewBox="0 0 34 46" xmlns="http://www.w3.org/2000/svg">
  <path d="M17 0C7.6 0 0 7.6 0 17c0 12 17 29 17 29s17-17 17-29C34 7.6 26.4 0 17 0z" fill="${color}"/>
  <circle cx="17" cy="17" r="7" fill="#F7F3EA"/>
</svg>`;

const makeIcon = (color, active) =>
  L.divIcon({
    className: "fg-pin",
    html: pinSvg(active ? "#7B473C" : color),
    iconSize: active ? [42, 56] : [34, 46],
    iconAnchor: active ? [21, 56] : [17, 46],
  });

function MapController({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    if (center) {
      map.flyTo(center, zoom || 11, { duration: 0.8 });
    }
  }, [center, zoom, map]);
  useEffect(() => {
    setTimeout(() => map.invalidateSize(), 200);
  }, [map]);
  return null;
}

const FarmMap = ({ farms = [], center, radiusMiles, selectedId, onSelect }) => {
  const iconGreen = useMemo(() => makeIcon("#2F3E33", false), []);
  const iconActive = useMemo(() => makeIcon("#2F3E33", true), []);

  return (
    <MapContainer
      center={UK_CENTER}
      zoom={UK_ZOOM}
      scrollWheelZoom
      style={{ height: "100%", width: "100%" }}
      data-testid="live-map"
    >
      <TileLayer
        attribution='&copy; OpenStreetMap contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <MapController center={center} zoom={center ? 11 : UK_ZOOM} />
      {center && radiusMiles && (
        <Circle
          center={center}
          radius={radiusMiles * 1609.34}
          pathOptions={{ color: "#556B2F", fillColor: "#8FB573", fillOpacity: 0.08, weight: 1 }}
        />
      )}
      {farms.map((f) => (
        <Marker
          key={f.id}
          position={[f.latitude, f.longitude]}
          icon={selectedId === f.id ? iconActive : iconGreen}
          eventHandlers={{ click: () => onSelect && onSelect(f) }}
        />
      ))}
    </MapContainer>
  );
};

export default FarmMap;
